module.exports = __webpack_public_path__ + "static/media/10.8f3daf3f.jpg";